import _ from 'lodash';
import React, { Fragment, Component } from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import Dropzone from 'react-dropzone';

import config from 'client/shared/config';

import {HFMModalNeo} from 'client/shared/components';
import {ImageUpload} from 'client/shared/components';

const resolveDisplayImagePath = (imgSrc, imgBasePath) => {
	if (_.isEmpty(imgSrc)) {

		return '';
	}
	const s = String(imgSrc);
	if ((/^data:|^https?:\/\//i).test(s)) {

		return s;
	}

	return `${_.compact([imgBasePath, s.replace(/^\//, '')]).join('/')}`;
};

class ActionComp extends Component {

	render () {
		const {
			imgSrc,
			imgPath,
			onDrop,
			onClick,
			fullWidth,
			imgClassName,
			displayAsButton = true
		} = this.props;

		if (displayAsButton) {

			return (
				<button className="button secondary clear" onClick={ onClick }>
					Edit Image
				</button>
			);
		}

		if (_.isEmpty(imgSrc)) {

			return (
				<Dropzone
					accept="image/*"
					onDrop={ onDrop }
				>
					{
						({getRootProps, getInputProps}) => (
							<section>
								<div
									{
										...getRootProps({
											className: `drop-zone${ fullWidth ? ' full-width' : '' }`
										})
									}
								>
									<input {...getInputProps()} />
									<span className="fas fa-image"></span>
									<br />
									<strong>
										Drag &amp; drop your .jpg/.jpeg or .png files
										<br />
										or click here.
									</strong>
								</div>
							</section>
						)
					}
				</Dropzone>
			);
		}

		const styles = {
			backgroundImage: `url(${ (/^data/).test(imgSrc) ? imgSrc : imgPath })`
		};

		return (
			<div className={ `edit-image ${imgClassName}` } style={ styles } onClick={ onClick }></div>
		);
	}
}

@observer
class EditImage extends Component {
	state = {
		imgSrc: this.props.imgSrc,
		isModalOpen: false
	}

	render () {
		const {
			store,
			item,
			height = 400,
			width = 400,
			aspectRatio = 1,
			buttonText = 'Upload Image',
			fullWidth = false,
			alwaysShowUpload = false,
			displayAsButton = false,
			imgClassName = 'image medium',
			imgBasePath = config.paths.imgBasePath
		} = this.props;

		const { imgSrc, isModalOpen } = this.state;
		const imgPath = resolveDisplayImagePath(imgSrc, imgBasePath);
		return (
			<div className={`image-wrapper${ fullWidth ? ' full-width' : '' }`}>
				<HFMModalNeo
					isOpen={ isModalOpen }
					contentLabel="Edit Image"
				>
					<ImageUpload
						imgSrc={ imgSrc }
						imgPath={ imgPath }
						store={ store }
						item={ item }
						height={ height }
						width={ width }
						aspectRatio={ aspectRatio }
						imgClassName={ imgClassName }
						handleImageCrop={ this.handleImageCrop }
					>
						<button
							className="button neo margin-right-1"
							onClick={ this.handleCloseModal }
						>
							Close
						</button>
					</ImageUpload>
				</HFMModalNeo>

				<ActionComp
					fullWidth
					onDrop={ this.onDrop }
					onClick={ this.handleOpenModal }
					imgClassName={ imgClassName }
					imgPath={ imgPath }
					buttonText={ buttonText }
					displayAsButton={ displayAsButton }
					imgSrc={ alwaysShowUpload ? '' : imgSrc }
				/>
			</div>
		);
	}

	@autobind
	handleImageCrop (cropResult) {
		const { handleImageCrop = _.noop } = this.props;

		this.setState({
			imgSrc: cropResult
		});

		handleImageCrop(cropResult);

		this.handleCloseModal();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			isModalOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			isModalOpen: false
		});
	}

	@autobind
	onDrop ([ file ]) {
		const { store, item } = this.props;

		if (item) {

			item.uploadFile = file;
		} else {

			store.set({
				key: 'editImage.uploadImage',
				value: file
			});
		}

		this.handleOpenModal();
	}
}

export default EditImage;
